<template>
  <div class="specials section-pad" id="gosteps">
    <div class="container">
      <h5 class="main-title text-center mb-4">{{ $t('orderSteps.orderSteps') }}</h5>
      <div class="stepsRow">
        <div v-for="step , i in orderStepsData" :key="step.id" class="row mb-3">
          <div class="col-md-5 col-12 mb-3">
            <div class="img-container-step">
              <img :src="step.image" alt="" />
            </div>
          </div>
          <div class="col-md-7 col-12 mb-3">
            <div class="flex-colomn-100 h-100">
              <div class="info-container-step">
                <div class="number-circle mb-3">{{ i + 1 }}</div>
                <div class="step-line-big mb-3">{{ step.title }}</div>
                <p class="main-p mb-3">
                  {{ step.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";

// props
const props = defineProps(["orderStepsData"]);

// mounted
onMounted(() => {
  console.log(props);
});
</script>
